import repository from '@/repositories/repository'

export default baseUrl => {
    baseUrl = `${baseUrl}/exame-solicitado-status`

    return {
        list(queryParms = {}) {

            return repository.post(`${baseUrl}/list`, queryParms)
        },
        loadFields(queryParms = {}) {

            return repository.post(`${baseUrl}/load-field`, queryParms)
        },
    }
}
